import { render, staticRenderFns } from "./rfid.vue?vue&type=template&id=7c6f87ba&scoped=true"
import script from "./rfid.vue?vue&type=script&lang=js"
export * from "./rfid.vue?vue&type=script&lang=js"
import style0 from "./rfid.vue?vue&type=style&index=0&id=7c6f87ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6f87ba",
  null
  
)

export default component.exports